import React, { useState } from 'react';
import { deleteProject } from '../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import grey from "@material-ui/core/colors/grey";
import AlertDialog from './Dialog';
import './DeleteButton.css';

const DeleteButton = (props) => {

    const [clickedDelete, setClickedDelete] = useState(false);

    const deleteWebProject = async () =>{

        if(clickedDelete) {
            props.setLoading(true);
            
            try {
        
                let delete_project_data = {
                    id: props.id,
                    type: props.type, 
                }
                
                await API.graphql(graphqlOperation(deleteProject, {input: delete_project_data}))
                props.doUpdate(true);
                props.setSnackBar(true);
    
            }
    
            catch(error){
                console.log(error)
                props.setWarning(true);
    
            }
        }
    }


    const handleDeleteClick = () =>{

        setClickedDelete(true);

    }

    const handleDeleteAgree = () => { 
           
        deleteWebProject();
        setClickedDelete(false);
        props.setHover(false);

    }

    const handleDeleteClose = () => {

        setClickedDelete(false);
        props.setHover(false);

    }

    const renderDeleteAlert = () => {

        return (<AlertDialog agree={handleDeleteAgree} canceltxt={'Cancel'} proceedtxt={'Yes, delete it!'} close={handleDeleteClose}>Do you really want to delete this project?</AlertDialog>)

    }



    return (
        <>
        {clickedDelete && renderDeleteAlert()}
        <button 
        className='delete-btn'
        onClick={handleDeleteClick}>
            <DeleteForeverIcon style={{ color: grey[50] }} />
        </button>
        </>
    )

}

export default DeleteButton;